/* ======================================
   Maison d'Etto v2 — <v2-chip-filter>
   Client-side filter for a list already on the page, driven by a <v2-chip-strip>
   inside it (WS 06: chips filter, they never gate; no page load between chips).
   Used by the Journal index and the Stockists page; the shop has its own ranking
   script on top of the same strip.
   - items carry data-filter-keys="a|b|" (handleized); an item shows when any of
     its keys is pressed, or when nothing is pressed (All)
   - optional [data-filter-count] gets "N <data-count-label>", optional
     [data-filter-empty] shows when nothing matches
   - state mirrors into the URL under data-param (e.g. ?tag=studio) and is
     restored on load
   - data-navigate="/blogs/journal": the list on the page is already filtered by
     the server (a /tagged/ URL), so a chip press navigates to that base with
     ?param=key instead of filtering, and no chip is hidden
   ====================================== */
(function () {
  'use strict';

  var split = function (str) { return (str || '').split('|').filter(Boolean); };

  class V2ChipFilter extends HTMLElement {
    connectedCallback() {
      var self = this;
      customElements.whenDefined('v2-chip-strip').then(function () { if (self.isConnected) self.init(); });
    }

    init() {
      this.strip = this.querySelector('v2-chip-strip');
      this.items = [...this.querySelectorAll('[data-filter-keys]')];
      this.countEls = [...this.querySelectorAll('[data-filter-count]')];
      this.emptyEl = this.querySelector('[data-filter-empty]');
      this.param = this.dataset.param || '';
      this.navigate = this.dataset.navigate || '';
      if (!this.strip) return;

      this.onChips = this.handleChips.bind(this);
      this.addEventListener('v2:chips', this.onChips);

      /* chips no item carries are hidden, outside the editor (not on a server-filtered page: every chip is a way out) */
      if (!this.navigate && !document.documentElement.classList.contains('v2-in-editor')) {
        var self = this;
        [...this.strip.querySelectorAll('[data-chip]')].forEach(function (chip) {
          var key = chip.dataset.chip;
          if (key === 'all') return;
          chip.hidden = !self.items.some(function (i) { return split(i.dataset.filterKeys).indexOf(key) !== -1; });
        });
        this.strip.sync();
      }

      var keys = this.strip.keys(); /* the markup's pressed state, e.g. the tag a /tagged/ URL was rendered for */
      if (this.param) {
        var raw = new URLSearchParams(location.search).get(this.param);
        if (raw !== null) {
          keys = raw.split(',').filter(Boolean).filter(function (k) { return !!this.strip.find(k); }, this);
          this.strip.set(keys);
        }
      }
      this.render(keys, false);
    }

    disconnectedCallback() {
      this.removeEventListener('v2:chips', this.onChips);
    }

    handleChips(e) {
      if (this.navigate) {
        var keys = e.detail.keys;
        location.href = this.navigate + (keys.length && this.param ? '?' + this.param + '=' + encodeURIComponent(keys.join(',')) : '');
        return;
      }
      this.render(e.detail.keys, true);
    }

    render(keys, pushUrl) {
      if (this.navigate) return; /* the server already filtered the list */
      var n = 0;
      this.items.forEach(function (item) {
        var show = !keys.length || split(item.dataset.filterKeys).some(function (k) { return keys.indexOf(k) !== -1; });
        item.hidden = !show;
        if (show) n++;
      });
      if (this.countEls.length) {
        var label = this.dataset.countLabel || '';
        this.countEls.forEach(function (el) { el.textContent = n + (label ? ' ' + label : ''); });
      }
      if (this.emptyEl) this.emptyEl.hidden = n > 0;
      if (pushUrl && this.param) {
        var url = new URL(location.href);
        if (keys.length) url.searchParams.set(this.param, keys.join(',')); else url.searchParams.delete(this.param);
        history.replaceState(null, '', url.pathname + (url.search || '') + url.hash);
      }
      if (window.V2Reveal) window.V2Reveal(this);
    }
  }

  if (!customElements.get('v2-chip-filter')) {
    customElements.define('v2-chip-filter', V2ChipFilter);
  }
})();
